import type { Phase } from "./duel";

/** Extra mid-countdown coaching (not tied to a phase enter). */
export const TUTORIAL_TAUNT_GATE = "taunt";
export const TUTORIAL_TAUNT_AT_MS = 4000;
export const TUTORIAL_TAUNT_TIP =
  "Oh yeah, you can taunt your opponent with 'T' but be careful, it will alert the enemy to your approximate location.";

/** Ability-pick coaching before the first duel. */
export const TUTORIAL_ABILITIES_GATE = "abilities";
export const TUTORIAL_ABILITIES_TIP =
  "Before every match you must pick 2 tricks that you can use to your advantage. Hover over each one to read what they do.";

/** Phase-by-phase coaching copy for Tutorial mode. */
export function tipForPhase(phase: Phase): string | null {
  switch (phase) {
    case "settle":
      return "Now, stand there and look your opponent in the eye. You are always dressed in blue and they are always dressed in black.";
    case "maneuver":
      return "The bell starts the countdown. Each second you will automatically pace toward your mouse. Their half is hidden until the start of the duel.";
    case "aim":
      return "The duel starts at the sound of a whip. Turn to your opponent, hold still to tighten your aim, then click to fire. Or, just spray and pray.";
    default:
      return null;
  }
}

/** Phases that show a gate modal before play continues. */
export function isTutorialGatePhase(phase: Phase): boolean {
  return tipForPhase(phase) !== null;
}
